/**
 * The one routine that draws a tetromino centred in a box — hold slots, next
 * queues and instrument bands all want it, at three different cell sizes.
 */

import { PIECE_COLORS, SHAPES, type PieceType } from '../core/piece.ts';
import type { Painter } from './painter.ts';
import { bevelInset, faces } from './theme.ts';

export function drawMiniPiece(
  p: Painter,
  type: PieceType,
  boxX: number,
  boxY: number,
  boxW: number,
  boxH: number,
  cell: number,
  alpha = 1,
): void {
  const cells = SHAPES[type][0];
  const minX = Math.min(...cells.map((c) => c.x));
  const maxX = Math.max(...cells.map((c) => c.x));
  const minY = Math.min(...cells.map((c) => c.y));
  const maxY = Math.max(...cells.map((c) => c.y));
  const originX = boxX + (boxW - (maxX - minX + 1) * cell) / 2;
  const originY = boxY + (boxH - (maxY - minY + 1) * cell) / 2;
  const f = faces(PIECE_COLORS[type]);
  const inset = bevelInset(cell);

  const ctx = p.ctx;
  ctx.save();
  ctx.globalAlpha = alpha;
  for (const c of cells) {
    p.bevelRect(
      Math.round(originX + (c.x - minX) * cell),
      Math.round(originY + (c.y - minY) * cell),
      cell,
      cell,
      f,
      inset,
    );
  }
  ctx.restore();
}
